export default __webpack_public_path__ + "static/media/nurse_slide_3.19ab78af.png";